import { render } from "./booking-commission-form-criteria-booking.vue?vue&type=template&id=18a5e2f4&ts=true"
import script from "./booking-commission-form-criteria-booking.vue?vue&type=script&lang=ts"
export * from "./booking-commission-form-criteria-booking.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__